<template>
  <div class="w-36 h-20 relative">
    <input
      class="toggle-button absolute left-0 top-0 z-3 o-0 w-36 h-20 hand"
      type="checkbox"
      :checked="checkInit"
      @input="handleChecked"
      :id='id'
    />
    <div
      class="toggle-slide bg-gray-medium absolute top-0 left-0 pa-2 br-13"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'ToggleButton',
  emits: ['update:checked', 'trigger'],
  props: {
    checked: { type: Boolean, default: false },
    checkInit: { type: Boolean, default: false },
    id: { type: String, default: ''}
  },
  setup(props, { emit }) {
    const handleChecked = (e) => {
      emit('update:checked', e.target.checked)
      emit('trigger')
    }
    return { handleChecked }
  },
}
</script>

<style lang="scss" scoped>
.toggle-slide {
  z-index: 1;
  width: 100%;
  height: 100%;
  &:before,
  &:after {
    content: '';
    width: 16px;
    height: 16px;
    border-radius: 50%;
    display: block;
    -webkit-transition: 0.4s;
    transition: 0.4s;
    position: absolute;
  }
  &:before {
    background-color: white;
  }
  //&:after {
  //  background-image: url('https://s3-cdn.designerjourneys.com/static/icons/icon-toggle-check.svg');
  //  background-position: 6px;
  //  background-repeat: no-repeat;
  //  opacity: 0;
  //}
}

.toggle-button:checked + .toggle-slide {
  background-color: brandColor(brand,800);
}

.toggle-button:checked + .toggle-slide:before,
.toggle-button:checked + .toggle-slide:after {
  -webkit-transform: translateX(16px);
  -ms-transform: translateX(16px);
  transform: translateX(16px);
}

.toggle-button:checked + .toggle-slide:after {
  opacity: 1;
}
</style>
